import { render, staticRenderFns } from "./DashboardDetailModal.vue?vue&type=template&id=5e127785&scoped=true&"
import script from "./DashboardDetailModal.vue?vue&type=script&lang=js&"
export * from "./DashboardDetailModal.vue?vue&type=script&lang=js&"
import style0 from "./DashboardDetailModal.vue?vue&type=style&index=0&id=5e127785&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e127785",
  null
  
)

export default component.exports